module.exports = "/fast-coin/img/header-babaijebu.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/header-babaijebu.png
// module id = 366
// module chunks = 5